import {getField, updateField} from 'vuex-map-fields';
import BaseTableModule from '@/commonFunction/baseTableModule'

let mpnresearch = new BaseTableModule('/ws/mpnresearch/');

const state = {
    ...mpnresearch.state,
    columns: [
                // {text: 'Actions', value: 'actions', sortable: false, divider: true, brief: true,},
                {text: 'Name', value: 'name', sortable: true, filterable: true, divider: true, brief: true,},
                {text: 'Description', value: 'description', sortable: true, divider: true, brief: true,},
                {text: 'Created by', value: 'created_by__username', sortable: true, divider: true, brief: true,},
                {text: 'Created on', value: 'created_on', sortable: true, divider: true, brief: true,},
                // {text: 'Edited by', value: 'edited_by__username', sortable: true, divider: true, brief: true,},
                // {text: 'Edited on', value: 'edited_on', sortable: true, divider: true, brief: true,},
            ],
    briefView: true,
    options: {
                page: 1,
                itemsPerPage: 20,
                sortBy: ['-created_on'],
                sortDesc: [false],
                multiSort: false,
                mustSort: true,
                descending: true,

            },
};
const getters = {
    ...mpnresearch.getters,
    getColumns(state) {
                if (state.briefView) {
                    return state.columns.filter(row => row.brief === true)
                } else {
                    return state.columns
                }
            },
};
const actions = {
    ...mpnresearch.actions,
};
const mutations = {
    ...mpnresearch.mutations,
};

export default {
    modules: {
        MPNResearch: {
            namespaced: true,
            state,
            getters,
            actions,
            mutations
        }
    }
}